module.exports = "* {\n    padding: 15px;\n    background-color: #ffffff;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/tickets/tickets.component.css
// module id = 990
// module chunks = 7